
export default function ContactCTA() {
  const packages = [
    {
      name: 'Starter',
      price: '$350',
      description: 'Perfect for testing UGC',
      features: ['1 UGC Video (15-30s)', 'Raw footage included', '1 revision round', '5-day delivery'],
      popular: false
    },
    {
      name: 'Growth',
      price: '$900',
      description: 'Most popular for brands',
      features: ['3 UGC Videos (15-60s)', 'Raw footage included', '2 revision rounds', 'Hook variations', '7-day delivery'],
      popular: true
    },
    {
      name: 'Scale',
      price: '$2,000',
      description: 'For serious campaigns',
      features: ['8 UGC Videos', '10 Static images', 'Unlimited revisions', 'Priority delivery', 'Usage rights included'],
      popular: false
    }
  ];

  return (
    <section id="contact" className="py-16 md:py-24 bg-stone-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16">
          <div className="text-xs uppercase tracking-widest text-amber-700 mb-3 md:mb-4">Pricing</div>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-3 md:mb-4">
            Simple & <span className="font-light italic">Transparent</span>
          </h2>
          <p className="text-base md:text-lg text-stone-500 max-w-xl mx-auto px-4">
            Choose a package that fits your needs or reach out for custom pricing
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-12 md:mb-20">
          {packages.map((pkg, index) => (
            <div
              key={index}
              className={`rounded-2xl md:rounded-3xl p-6 md:p-8 transition-all duration-300 ${
                pkg.popular 
                  ? 'bg-stone-900 text-white md:scale-105 shadow-2xl' 
                  : 'bg-white hover:shadow-xl'
              }`}
            >
              {pkg.popular && (
                <div className="inline-block bg-amber-500 text-white px-3 py-1 rounded-full text-xs font-bold mb-3 md:mb-4">
                  MOST POPULAR
                </div>
              )}
              
              <h3 className={`text-lg md:text-xl font-bold mb-2 ${pkg.popular ? 'text-white' : 'text-stone-900'}`}>
                {pkg.name}
              </h3>
              <p className={`text-xs md:text-sm mb-4 md:mb-6 ${pkg.popular ? 'text-stone-300' : 'text-stone-500'}`}>
                {pkg.description}
              </p>
              
              <div className="mb-4 md:mb-6">
                <span className={`text-3xl md:text-4xl font-bold ${pkg.popular ? 'text-white' : 'text-stone-900'}`}>
                  {pkg.price}
                </span>
                <span className={`text-xs md:text-sm ${pkg.popular ? 'text-stone-300' : 'text-stone-500'}`}> / package</span>
              </div>
              
              <div className="space-y-2 md:space-y-3 mb-6 md:mb-8">
                {pkg.features.map((feature, i) => (
                  <div key={i} className="flex items-center gap-2 md:gap-3">
                    <i className={`ri-check-line ${pkg.popular ? 'text-amber-500' : 'text-green-600'}`}></i>
                    <span className={`text-xs md:text-sm ${pkg.popular ? 'text-stone-200' : 'text-stone-600'}`}>
                      {feature}
                    </span>
                  </div>
                ))}
              </div>
              
              <a
                href="mailto:hello@sarahcreates.com"
                className={`block text-center py-3 md:py-4 rounded-full text-sm md:text-base font-medium transition-all cursor-pointer whitespace-nowrap ${
                  pkg.popular 
                    ? 'bg-white text-stone-900 hover:bg-stone-100' 
                    : 'bg-stone-900 text-white hover:bg-stone-800'
                }`}
              >
                Get Started
              </a>
            </div>
          ))}
        </div>

        {/* Contact Form CTA */}
        <div className="bg-amber-50 rounded-2xl md:rounded-3xl p-8 md:p-12 text-center">
          <h3 className="text-xl md:text-2xl font-bold text-stone-900 mb-3 md:mb-4">
            Need a Custom Package?
          </h3>
          <p className="text-sm md:text-base text-stone-600 mb-6 md:mb-8 max-w-lg mx-auto px-4">
            Have a larger campaign or specific requirements? Let's chat about a custom solution for your brand.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="mailto:hello@sarahcreates.com"
              className="w-full sm:w-auto bg-stone-900 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-medium hover:bg-stone-800 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-mail-line"></i>
              hello@sarahcreates.com
            </a>
            <a
              href="https://instagram.com/sarahcreates"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto bg-white border-2 border-stone-900 text-stone-900 px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-medium hover:bg-stone-900 hover:text-white transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-instagram-line"></i>
              @sarahcreates
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
